import { render } from "./SettingsAddAdmin.vue?vue&type=template&id=52d21b7a"
import script from "./SettingsAddAdmin.vue?vue&type=script&lang=js"
export * from "./SettingsAddAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ofmartinez/WebDev/orbeas/Holton-OrbeasRogue-Web-Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__